import { render } from "./AppTraining.vue?vue&type=template&id=5e22abac&scoped=true"
import script from "./AppTraining.vue?vue&type=script&lang=js"
export * from "./AppTraining.vue?vue&type=script&lang=js"

import "./AppTraining.vue?vue&type=style&index=0&id=5e22abac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e22abac"]])

export default __exports__